export const getters = {
  systemEmployeedeductions: state => state.employeedeductions,
  Deduction: state => state.systemDeduction
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/employeedeductions/getters.js